module.exports = __webpack_public_path__ + "static/media/validate_step_build.bc02aa28.png";